import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { AuthState } from '@/store/modules/auth/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import state from './state';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<AuthState, RootState>;
